// list of valid watchlist names
export enum TitleListName {
	WATCHLIST = 'watchlist',
	SEENLIST = 'seenlist',
	LIKELIST = 'likelist',
	DISLIKELIST = 'dislikelist',
	TVST = 'tvst',
	MORELIST = 'morelist',
}
